# Generated by https://pagedraw.io/pages/1470
React = require 'react'
createReactClass = require 'create-react-class'
Logo = require './logo'


module.exports = Banner = createReactClass {
    displayName: 'Banner'
    render: ->
        React.createElement("div", {"className": "banner-banner-7"},
          React.createElement("style", {"dangerouslySetInnerHTML": (__html: """
              @import url('https://fonts.googleapis.com/css?family=Lato:300|Lato:');
              
              .banner-banner-7 {
                  display: flex;
                  flex-direction: column;
                  flex-grow: 1;
                  background: rgb(42, 42, 89);
              }
              
              .banner-0 {
                  display: flex;
                  flex-shrink: 0;
                  justify-content: center;
              }
              
              .banner-fixed-content-wrapper-5 {
                  display: flex;
                  flex-direction: column;
                  padding-top: 33px;
                  padding-bottom: 13px;
              }
              
              .banner-0-0-0 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .banner-0-0-0-0 {
                  display: flex;
                  flex-direction: column;
                  padding-bottom: 3px;
              }
              
              .banner-0-0-0-0-0 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .banner-0-0-0-0-0-0 {
                  flex-shrink: 0;
                  display: flex;
              }
              
              .banner-logo_instance-1 {
                  display: flex;
                  flex-direction: column;
                  flex-grow: 1;
              }
              
              .banner-0-0-0-1 {
                  display: flex;
                  flex-direction: column;
                  margin-left: 199px;
                  padding-top: 15px;
                  padding-bottom: 5px;
              }
              
              .banner-0-0-0-1-0 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .banner-0-0-0-1-0-0 {
                  flex-shrink: 0;
                  display: flex;
              }
              
              .banner-text-7 {
                  font-family: "Lato", sans-serif;
                  color: rgba(255, 255, 255, 0.7);
                  font-size: 17px;
                  line-height: normal;
                  letter-spacing: 0px;
                  font-weight: 300;
                  font-style: normal;
                  text-decoration: none;
                  text-align: left;
                  word-wrap: break-word;
                  padding-right: 0.8125px;
                  flex-grow: 1;
              }
              
              .banner-0-0-0-2 {
                  display: flex;
                  flex-direction: column;
                  margin-left: 46px;
                  padding-top: 15px;
                  padding-bottom: 5px;
              }
              
              .banner-0-0-0-2-0 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .banner-0-0-0-2-0-0 {
                  flex-shrink: 0;
                  display: flex;
              }
              
              .banner-text-3 {
                  font-family: "Lato", sans-serif;
                  color: rgba(255, 255, 255, 0.7);
                  font-size: 17px;
                  line-height: normal;
                  letter-spacing: 0px;
                  font-weight: 300;
                  font-style: normal;
                  text-decoration: none;
                  text-align: left;
                  word-wrap: break-word;
                  padding-right: 0.859375px;
                  flex-grow: 1;
              }
              
              .banner-0-0-0-3 {
                  display: flex;
                  flex-direction: column;
                  margin-left: 47px;
                  padding-top: 15px;
                  padding-bottom: 5px;
              }
              
              .banner-0-0-0-3-0 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .banner-0-0-0-3-0-0 {
                  flex-shrink: 0;
                  display: flex;
              }
              
              .banner-text-8 {
                  font-family: "Lato", sans-serif;
                  color: rgba(255, 255, 255, 0.7);
                  font-size: 17px;
                  line-height: normal;
                  letter-spacing: 0px;
                  font-weight: 300;
                  font-style: normal;
                  text-decoration: none;
                  text-align: left;
                  word-wrap: break-word;
                  padding-right: 0.71875px;
                  flex-grow: 1;
              }
              
              .banner-0-0-0-4 {
                  display: flex;
                  flex-direction: column;
                  margin-left: 55px;
                  padding-top: 15px;
                  padding-bottom: 5px;
              }
              
              .banner-0-0-0-4-0 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .banner-text_1 {
                  width: 267px;
                  flex-shrink: 0;
                  font-family: "Lato", sans-serif;
                  color: rgba(255, 255, 255, 0.7);
                  font-size: 17px;
                  line-height: normal;
                  letter-spacing: 0px;
                  font-weight: 300;
                  font-style: normal;
                  text-decoration: none;
                  text-align: right;
                  word-wrap: break-word;
              }
              
              .banner-0-0-0-5 {
                  display: flex;
                  flex-direction: column;
                  margin-left: 13px;
                  padding-top: 9px;
              }
              
              .banner-0-0-0-5-0 {
                  display: flex;
                  flex-shrink: 0;
              }
              
              .banner-rectangle_3 {
                  display: flex;
                  flex-direction: column;
                  padding-top: 10px;
                  padding-bottom: 9px;
                  border-radius: 6px;
                  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.32);
                  cursor: pointer;
                  background: rgba(255, 255, 255, 0.7);
              }
              
              .banner-0-0-0-5-0-0-0 {
                  display: flex;
                  flex-shrink: 0;
                  padding-left: 9px;
                  padding-right: 11px;
              }
              
              .banner-text_2 {
                  flex-shrink: 0;
                  font-family: "Lato", sans-serif;
                  color: rgb(42, 42, 89);
                  font-size: 11px;
                  line-height: normal;
                  letter-spacing: 0px;
                  font-weight: normal;
                  font-style: normal;
                  text-decoration: none;
                  text-align: center;
                  word-wrap: break-word;
                  padding-right: 0.5px;
              }
              
              * {
                  box-sizing: border-box;
              }
              
              body {
                  margin: 0;
              }
              
              button:hover {
                  cursor: pointer;
              }
              
              a {
                  text-decoration: none;
                  color: inherit;
              }
              
              .pd-onhover-parent >.pd-onhover {
                  display: none;
              }
              
              .pd-onhover-parent:hover > * {
                  display: none;
              }
              
              .pd-onhover-parent:hover > .pd-onhover {
                  display: flex;
              }
              
              .pd-onactive-parent > .pd-onactive {
                  display: none;
              }
              
              .pd-onactive-parent:active > * {
                  display: none;
              }
              
              .pd-onactive-parent:active > .pd-onactive {
                  display: flex;
              }
              
              .pd-onactive-parent.pd-onhover-parent:active > .pd-onhover {
                  display: none;
              }
          """)}),  
          React.createElement("div", {"className": "banner-0"},
              React.createElement("div", {"className": "banner-fixed-content-wrapper-5"},
                  React.createElement("div", {"className": "banner-0-0-0"},
                      React.createElement("div", {"className": "banner-0-0-0-0"},
                          React.createElement("div", {"className": "banner-0-0-0-0-0"},
                              React.createElement("a", {"href": "https://pagedraw.io/", "className": "banner-0-0-0-0-0-0"},
                                  React.createElement("div", {"className": "banner-logo_instance-1"}, React.createElement(Logo, null), " ")
                              )
                          )
                      ),
                      React.createElement("div", {"className": "banner-0-0-0-1"},
                          React.createElement("div", {"className": "banner-0-0-0-1-0"},
                              React.createElement("a", {"href": "https://pagedraw.io/tutorials/basics", "className": "banner-0-0-0-1-0-0"},
                                  React.createElement("div", {"className": "banner-text-7"}, "Get started")
                              )
                          )
                      ),
                      React.createElement("div", {"className": "banner-0-0-0-2"},
                          React.createElement("div", {"className": "banner-0-0-0-2-0"},
                              React.createElement("a", {"href": "https://pagedraw.io/tutorials/basics", "className": "banner-0-0-0-2-0-0"},
                                  React.createElement("div", {"className": "banner-text-3"}, "Tutorial")
                              )
                          )
                      ),
                      React.createElement("div", {"className": "banner-0-0-0-3"},
                          React.createElement("div", {"className": "banner-0-0-0-3-0"},
                              React.createElement("a", {"href": "https://documentation.pagedraw.io/", "className": "banner-0-0-0-3-0-0"},
                                  React.createElement("div", {"className": "banner-text-8"}, "Documentation")
                              )
                          )
                      ),
                      React.createElement("div", {"className": "banner-0-0-0-4"},
                          React.createElement("div", {"className": "banner-0-0-0-4-0"},
                              React.createElement("div", {"className": "banner-text_1"},
                                  ( this.props.username )
                              )
                          )
                      ),
                      React.createElement("div", {"className": "banner-0-0-0-5"},
                          React.createElement("div", {"className": "banner-0-0-0-5-0"},
                              React.createElement("div", {"onClick": (@props.logout), "className": "banner-rectangle_3"},
                                  React.createElement("div", {"className": "banner-0-0-0-5-0-0-0"},
                                      React.createElement("div", {"className": "banner-text_2"}, "LOG OUT")
                                  )
                              )
                          )
                      )
                  )
              )
          )
      )
}



// WEBPACK FOOTER //
// ./node_modules/cjsx-loader!./src/pagedraw/banner.cjsx